import { ComponentConfig } from "@measured/puck"
import { FooterGroupProps, RenderConfig } from "./RenderConfig"

export const FooterGroup: ComponentConfig<FooterGroupProps> = {
  label: "Tamda Group | Footer",
  fields: {
    office: {
      label: "Office",
      type: "text",
    },
    about: {
      label: "About",
      type: "text",
    },
    info: {
      label: "Info",
      type: "text",
    },
    copyright: {
      label: "Copyright",
      type: "text",
    },
    aboutLinks: {
      label: "About - Links",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    infoLinks: {
      label: "Info - Links",
      type: "array",
      arrayFields: {
        title: {
          label: "Title",
          type: "text",
        },
        url: {
          label: "URL",
          type: "text",
        },
      },
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    aboutLinks: [],
    infoLinks: [],
    className: "",
  },
  ...RenderConfig,
}
